import React, { useRef } from "react";
import { motion } from "framer-motion";
import "./MeetOurClients.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import client1 from "../Imges/Client-1.jpg";
import client2 from "../Imges/Client-2.jpg";
import client3 from "../Imges/Client-3.jpg";
import client4 from "../Imges/Client-4.jpg";
import client5 from "../Imges/Client-5.jpg";
import client6 from "../Imges/Client-6.jpg";
import client7 from "../Imges/Client-7.jpg";
import client8 from "../Imges/Client-8.jpg";
import client9 from "../Imges/Client-9.jpg";
import client10 from "../Imges/Client-10.jpg";
import client11 from "../Imges/Client-11.jpg";
import client12 from "../Imges/Client-12.jpg";
import client13 from "../Imges/Client-13.jpg";
import client14 from "../Imges/Client-14.jpg";
import client15 from "../Imges/Client-15.jpg";

const clientLogos = [
  { id: 1, img: client1, alt: "Bhavesh Academy" },
  { id: 2, img: client2, alt: "Senpai" },
  { id: 3, img: client3, alt: "Pet Easy" },
  { id: 4, img: client4, alt: "Immersiv Technologies" },
  { id: 5, img: client5, alt: "CLPL Fiber Broadband" },
  { id: 6, img: client6, alt: "Tech Corp" },
  { id: 7, img: client7, alt: "Design Studio" },
  { id: 8, img: client8, alt: "AI Solutions" },
  { id: 9, img: client9, alt: "Eco Energy" },
  { id: 10, img: client10, alt: "Bhavesh Academy" },
  { id: 11, img: client11, alt: "Senpai" },
  { id: 12, img: client12, alt: "Pet Easy" },
  { id: 13, img: client13, alt: "Immersiv Technologies" },
  { id: 14, img: client14, alt: "CLPL Fiber Broadband" },
  { id: 15, img: client15, alt: "Bhavesh Academy" },
];

const MeetOurClients = () => {
  const sectionRef = useRef(null);

  return (
    <section ref={sectionRef} className="meet-our-clients">
      <p className="subtitle" style={{ textAlign: "center" }}>
        " We make every customer feel like a VIP "
      </p>
      <h2 className="section-title">
        <span className="title-bar">|</span> MEET OUR CLIENTS <span className="title-bar">|</span>
      </h2>

      <div className="swiper-wrapper">
        <Swiper
          spaceBetween={10}
          centeredSlides={true}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          modules={[Autoplay]}
          className="w-full max-w-5xl mx-auto"
          breakpoints={{
            0: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
            1440: { slidesPerView: 5 },
            2160: { slidesPerView: 6 },
          }}
        >
          {clientLogos.map((client, index) => (
            <SwiperSlide key={index}>
              {({ isActive }) => (
                <motion.div
                  animate={{
                    scale: isActive ? 1.2 : 0.8,
                    opacity: isActive ? 1 : 0.5,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="client-image-wrapper">
                    <img
                      src={client.img}
                      alt={client.alt}
                      onError={(e) => (e.target.src = "/placeholder.png")}
                    />
                  </div>
                </motion.div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default MeetOurClients;
